var Component = require("!../../node_modules/_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./BindPhone.vue"),
  /* template */
  require("!!../../node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2848b143\",\"hasScoped\":false}!../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./BindPhone.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/BindPhone.vue
// module id = 356
// module chunks = 7